import { color } from '../../../app/theme';

const IconChevronRight = ({
  className,
  id,
  width,
  height,
  iconColor,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id={`chevronRight${id}`}
        maskUnits="userSpaceOnUse"
        x="9"
        y="6"
        width="7"
        height="12"
      >
        <path
          d="M15.7375 12.6L10.4875 17.7429C10.3125 17.9143 10.1375 18 9.875 18C9.6125 18 9.4375 17.9143 9.2625 17.7429C8.9125 17.4 8.9125 16.8857 9.2625 16.5429L13.9 12L9.2625 7.45714C8.9125 7.11429 8.9125 6.6 9.2625 6.25714C9.6125 5.91429 10.1375 5.91429 10.4875 6.25714L15.7375 11.4C16.0875 11.7429 16.0875 12.2571 15.7375 12.6Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#chevronRight${id})`}>
        <rect width="24" height="24" fill={iconColor} />
      </g>
    </svg>
  );
};

IconChevronRight.defaultProps = {
  width: 24,
  height: 24,
  iconColor: color.$12,
};

export default IconChevronRight;
